import { cn } from '@anytag/shared-utils';
import { Icon, Modal, ModalProps } from '@anytag/shared-atoms';

export interface CarouselModalProps extends ModalProps {
  onClickNext?: () => void;
  onClickPrev?: () => void;
  siblingPostId?: { prevId: string | number | null; nextId: string | number | null };
}

export const CarouselModal = ({
  children,
  classNames,
  onClickNext,
  onClickPrev,
  siblingPostId,
  ...restProps
}: CarouselModalProps) => {
  const hasLeftButton = !!siblingPostId?.prevId;
  const hasRightButton = !!siblingPostId?.nextId;

  return (
    <Modal
      classNames={{
        ...classNames,
        // custom needed styles to add 2 next/prev buttons and handle overflow inside the children wrapper instead if the panel
        panel: cn(
          'mx-14 max-h-[unset]! overflow-visible p-0!',
          { 'mx-6': !hasLeftButton && !hasRightButton },
          classNames?.panel
        )
      }}
      {...restProps}
    >
      <button
        onClick={onClickPrev}
        disabled={!hasLeftButton}
        className={cn(styles.button, '-left-11.5 [&_.arrow-icon]:left-1.75', !hasLeftButton && 'hidden')}
      >
        <Icon icon="caret-left" size={15} variant="black" className="arrow-icon" />
      </button>
      <div className="max-h-[calc(100vh-3rem)] overflow-auto px-(--gutter) py-6 has-data-[slot=dialog-actions]:pb-0">
        {children}
      </div>
      <button
        onClick={onClickNext}
        disabled={!hasRightButton}
        className={cn(styles.button, '-right-11.5 [&_.arrow-icon]:right-1.75', !hasRightButton && 'hidden')}
      >
        <Icon icon="caret-right" size={15} variant="black" className="arrow-icon" />
      </button>
    </Modal>
  );
};
const styles = {
  button: cn(
    // base styles
    'absolute top-1/2 z-1 flex size-8 translate-y-[-50%] cursor-pointer rounded-full bg-white hover:opacity-80',
    // arrow icon styles
    '[&_.arrow-icon]:absolute [&_.arrow-icon]:top-1/2 [&_.arrow-icon]:translate-y-[-50%]'
  )
};
